import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import {Table} from 'react-bootstrap';
import moment from 'moment';
import {AsyncTypeahead} from 'react-bootstrap-typeahead';
import SvgIcon from 'react-icons-kit';
import {search} from 'react-icons-kit/icomoon/search';
import ModalPersonSearch from '../../generics/modal_person_search';

var Config = require('../../../config');

class ReservedSearch extends Component{
	constructor(props){
		super(props);

		this.patientSelected = this.patientSelected.bind(this);
		this.person_search = this.person_search.bind(this);

		this.state = {
			patients:[],
			index:-1,
			patient_selected:[],
			load:false,
			patient_id:"",
			reserved:[],
		}
	}

	componentDidMount(){
		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)
	}

	_handleSearchPatient = (query)=>{
		this.setState({load: true, patient_id:""});
	    
		fetch(Config.default.apiGateway.URL+'patients/with_reserve?search='+query,{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			if(response !== null){
				for (var i = 0; i < response.length; i++) {
					response[i].names = response[i].person.lastname1 +' '+ 
										(response[i].person.lastname2 !== undefined &&  response[i].person.lastname2 !== null ?
											response[i].person.lastname2+' ' : '')+
										response[i].person.names +' '+
										(response[i].person.birthday !== null ?
											' - '+moment(response[i].person.birthday).format('DD/MM/YYYY')
										: '')+
										(response[i].documents !== null ?
											response[i].documents.document_type !== ""?
												' - '+response[i].documents.document_type+' '+
												response[i].documents.document_number 	
											: ''
										: '')+
										(response[i].patient.number !== "" && response[i].patient.number !== null ?
											' - '+response[i].patient.number : '')+										
										(response[i].person.social_number !== null && response[i].person.social_number !== "" ?
											' - '+response[i].person.social_number : '');
					response[i].id = response[i].patient.id;
				};

				this.setState({
					load: false,
			     	patients: response,
			    });

			    setTimeout(()=>{
			    	if(this.modal_person_search.state.show){
			    		var id = '';
			    		this.modal_person_search.state.list.map((p)=>{
			    			if(p.check){
			    				id = p.person_id;
			    			}
			    		});

			    		var index = this.state.patients.findIndex(obj => 
			    			 parseInt(obj.person.id) === parseInt(id)
			    		);

			    		if(index !== -1){
			    			this.patientSelected([this.state.patients[index]]);
			    			this.modal_person_search.handleClose();
			    			this.props.waiting.handleClose();
			    		}else{
			    			swal('Información', 'El paciente no cuenta con reservas', 'info')
			    			this.modal_person_search.handleClose();
			    			this.props.waiting.handleClose();
			    		}
			    	}
			    	
			    }, 500);
			}
		})
	}

	patientSelected(e){
		var id = "";
		if(e.length > 0){
			
			id = e[0].patient.id 
			this.setState({patient_id:id, reserved:[]});

			this._typeahead.getInstance().clear();
			this.getList(id);
		}
	}

	getList(id){
		fetch(Config.default.apiGateway.URL+'unit_reserved/by_patient?patient_id='+id,{
			method:'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json',
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					reserved:response
				})
			}
		})
	}

	person_search(){
		this.modal_person_search.handleShow('Paciente','patients');
	}

	render(){
		const {t} = this.props;
		var session = sessionStorage.getItem('health_facilities_name');


		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{session} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.patients.MAIN')} ->
						Buscar Reservas Paciente
					</h5>
				</div>

				<div className="col-xs-12 form-group">
	            	<div className="col-xs-12 form-group">
						<div className="col-xs-12 col-sm-7">
				 			<span className="span-min">{t('content.generics.buttons.search')}</span>
					        <AsyncTypeahead
					          labelKey={(option) => `${option.names}`}
					          minLength={3}
					          maxLength={50}
					          name="patient"
					          id="patient"
					          onSearch={this._handleSearchPatient}
					          placeholder="Buscar por apellidos más nombre o número de documento..."
					          options={this.state.patients}
					          onChange={this.patientSelected}
					          ref={ref => this._typeahead = ref}
					          useCache={false}
					          isLoading={this.state.load}
					          delay={600}
					          paginationText="Mostrar mas resultados..."
					        />
				 		</div>
				 		<div className="col-xs-12 col-sm-1" style={{textAlign:'center', marginTop:'18px'}}>
							<SvgIcon icon={search} size={20} style={{cursor:'pointer'}} 
								onClick={this.person_search}/>
						</div>
					</div>



					<div className="col-xs-12 form-group">
						<Table responsive hover>
							<thead>
								<tr>
									<th>Nombre Paciente</th>
									<th>No. Expediente</th>
									<th>Fecha</th>
									<th>Grupo de Paciente</th>
									<th>Componente Reservado</th>
								</tr>
							</thead>
							<tbody>
								{this.state.reserved.map((res, i)=>(
									<tr key={i}>
										<td>{res.patient}</td>
										<td>{res.patient_number}</td>
										<td>{moment(res.timestamp).format('DD/MM/YYYY HH:mm')}</td>
										<td>
											{res.group+
												(res.rh === 'POSITIVO' ? '+' :
												res.rh === 'NEGATIVO' ? '-' : '')}
										</td>
										<td>{res.component}</td>
									</tr>
								))}
							</tbody>
						</Table>
					</div>

					
				</div>

				<ModalPersonSearch {...this.props} 
					waiting={this.props.waiting} 
					search={this.patientSelected} 
					onRef={ref => (this.modal_person_search = ref)}
				/>
			</div>
		)
	}
}

export default translate('translations')(ReservedSearch);

